import type { TypeShop } from '@/app/types/editor/shop';
import type { TypePage } from '@/app/types/editor/page';

/**
 * Wrapper State
 */
export class State {
  public shopInfo: TypeShop;
  public pageInfo: TypePage;
}

const state = new State();

export default state;
